export const app_store_chart_en = {
  "FREE": "Free",
  "PAID": "Paid",
  "GROSSING": "Grossing",
};
